import React from 'react';
import { ReactComponent as AlertFillIcon } from 'assets/icons/alert-fill.svg';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrowLeft.svg';
import './draftNotification.scss';

const DraftNotification = (props) => {
    const { text, btnText, handleClick } = props;

    return (
        <div className={`draft-notif rtl`}>
            <AlertFillIcon className="alert-icon" />
            <span className="alert-text">{text}</span>
            <button
                className="no-border is-brown show-draft-btn"
                onClick={handleClick}
            >
                {btnText}
                <ArrowLeftIcon />
            </button>
        </div>
    );
};

export default DraftNotification;
